import React from "react"
import { connect } from "react-redux"

import { setInfoPopupData, setShowInfoPopup } from "../../state/global"

import futures_83 from "../../images/community/83_futures.png"
import art_start from "../../images/community/art_start.png"
import jins from "../../images/community/jins.png"
import native_energy from "../../images/community/native_energy.png"
import skillshare from "../../images/community/skill_share.png"
import yellowbrick from "../../images/community/yellowbrick.png"
import one_equals from "../../images/community/1equals.png"

const COMMUNITY = [
  {
    name: "One For Equality",
    slug: "one-for-equality",
    detail:
      "AS A LASTING COMMITMENT AND ACKNOWLEDGEMENT THAT THE INJUSTICES EXPERIENCED BY POC ARE NOT A PASSING FAD, REED ART DEPARTMENT IS COMMITTING 1% OF ALL FUTURE NET PROFITS TO A SELECTED SET OF ORGANIZATIONS FOCUSED ON RACIAL EQUALITY, SOCIAL JUSTICE, AND CREATIVE EDUCATION.",
    logo: one_equals,
    link: "https://www.instagram.com/reedartdepartment/",
  },
  {
    name: "Native Energy",
    slug: "native-energy",
    detail:
      "WE ARE A PROUD SUPPORTER OF NATIVE ENERGY, AN NPO THAT HELPS BUSINESSES OFFSET THEIR CARBON FOOTPRINT. REED ART DEPARTMENT HAS COMMITTED TO OFFSETTING OUR ENTIRE CARBON OUTPUT.",
    logo: native_energy,
    link:
      "https://native.eco/project/waste-to-fuel-improving-agriculture-livelihoods-mexico/",
  },
  {
    name: "Art Start",
    slug: "art-start",
    detail:
      "WE ARE PASSIONATE ABOUT MENTORING THE NEXT GENERATION OF TALENT WHICH IS WHY WE SUPPORT ART START. ART START USES THE CREATIVE PROCESS TO NURTURE THE VOICES, HEARTS, AND MINDS OF HISTORICALLY MARGINALIZED YOUTH, OFFERING A SPACE FOR THEM TO IMAGINE, BELIEVE, AND REPRESENT THEIR CREATIVE VISION FOR THEIR LIVESAND COMMUNITIES.",
    logo: art_start,
    link: "http://www.art-start.org/",
  },
  {
    name: "Yellowbrick",
    slug: "yellowbrick",
    detail:
      "PARSONS SCHOOL OF DESIGN AND COMPLEX MEDIA TEAMED UP TO CREATE A “STREETWEAR ESSENTIALS” PROGRAM DESIGNED TO HELP STUDENTS LEARN EVERYTHING THEY NEED TO KNOW ABOUT THE INDUSTRY. WE ARE INVOLVED AS A MENTOR IN THE PROGRAM AND SUPPORT WITH TIME AND RESOURCESWHEN AVAILABLE.",
    logo: yellowbrick,
    link: "https://www.yellowbrick.co/streetwear/",
  },
  {
    name: "83 Futures",
    slug: "futures",
    detail:
      "83 FUTURES IS A PROGRAM DESIGNED TO ENCOURAGE ACTION THROUGH PRODUCT. AN EXCLUSIVE SHOP CONCEPT ONLY AVAILABLE TO ORGAN DONORS, WE HAVE PARTICIPATED IN THE PROGRAM BY DESIGNING SPECIAL ITEMS AND SUPPORTING CREATIVE/MARKETING EFFORTS BEHIND THE SCENES.",
    logo: futures_83,
    link: "https://www.83futures.com/",
  },

  // {
  //   name: "Jins",
  //   slug: "jins",
  //   detail:
  //     "WE ARE CURRENTLY WORKING WITH JAPANESE EYEGLASS BRAND, JINS, ON THEIR NEW CHARITY ART CASE PROGRAM. WE ARE WORKING WITH THE BRAND TO HELP THEM EXTEND INTO THE STREETWEAR/MEN’S DESIGN UNIVERSE. 100% OF THE PROCEEDS GOES TO ART START HELPING MARGINALIZED YOUTH GAIN THE MENTORSHIP THEY NEED.",
  //   logo: jins,
  //   link: "https://www.jins.com/us/cases-for-causes",
  // },
  {
    name: "Skillshare",
    slug: "skillshare",
    detail:
      "ONE OF THE MOST PROMINENT TEACHERS ON THE PLATFORM, JEFFSTAPLE HAS BEEN A PART OF THE ONLINE LEARNING RESOURCE SINCE ITS INCEPTION. WITH COURSES RANGING FROM BRAND SALES TO DESIGN TO PRODUCT MARKETING, OUR LESSONS HAVE TAUGHT OVER 30,000 PEOPLE THE INS AND OUTS OF OUR DYNAMIC INDUSTRY.",
    logo: skillshare,
    link: "https://www.skillshare.com/user/jeffstaple",
  },
]

const Community = ({ mobile, informationPopup, dispatch }) => {
  return mobile
    ? COMMUNITY.map((i, idx) => {
        return (
          <div
            key={idx}
            className="community-container-mobile"
            role="button"
            tabIndex={0}
            onKeyDown={() => {
              dispatch(setShowInfoPopup(true))
              dispatch(
                setInfoPopupData({
                  type: "community",
                  title: i.name,
                  info: i.detail,
                  link: i.link,
                })
              )
            }}
            onClick={() => {
              dispatch(setShowInfoPopup(true))
              dispatch(
                setInfoPopupData({
                  type: "community",
                  title: i.name,
                  info: i.detail,
                  link: i.link,
                })
              )
            }}
          >
            <div className="cm-logo-box">
              <img id={i.slug} src={i.logo} alt="" />
            </div>
          </div>
        )
      })
    : COMMUNITY.map((i, idx) => {
        return (
          <div key={idx} className="community-container">
            <div className="col-left">
              <img id={i.slug} src={i.logo} alt="" className="logo" />
            </div>
            <div className="col-right">
              <h2>{i.name}</h2>
              <div className="detail">{i.detail}</div>
              <a
                href={i.link}
                className="button main"
                rel="noopener noreferrer"
                target="_blank"
              >
                Learn More
              </a>
            </div>
          </div>
        )
      })
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    informationPopup: state.global.informationPopup,
  }),
  null
)(Community)
